<template>
    <UiHeader size="md" variant="sticky" no-container>
        <template #main>
            <UiLogo />
        </template>
        <template #actions>
            <div class="flex items-center gap-3 xl:gap-4">
                <slot name="items" />

                <div class="flex items-center gap-1 xl:hidden">
                    <slot name="mobile-items" />
                </div>

                <UiToggleButton 
                    variant="outline" 
                    shape="square" 
                    v-model="mobileMenuOpen"
                    class="xl:hidden"
                >
                    <template #before_label>
                        <UiIcon :name="mobileMenuOpen ? 'close' : 'menu'" class="w-5 h-5" />
                    </template>
                </UiToggleButton>

                <div class="hidden xl:flex xl:items-center xl:gap-4">
                    <slot name="desktop-items" />
                </div>
            </div>
        </template>
    </UiHeader>
</template>

<script setup lang="ts">
    import { UiHeader, UiLogo, UiToggleButton, UiIcon } from "@shopexperts/shared";

    const mobileMenuOpen = defineModel<boolean>({ required: true });
</script>
